module.exports = __webpack_public_path__ + "img/rodrigo-web-designer.d848f228.png";